import ApiBase from 'Services/Api/ApiBase';

class UserRates extends ApiBase {
    route = '/admin/human-resources/:user/user-rates';
};

export default new UserRates();